const  MuftiInsightsReduser = (state = [], action) => {
    switch (action.type) {
        case 'MUFTI_INSIGHTS_SUCCESS':
            return action.payload.res.data
        default:
            return state
    }
}
export default MuftiInsightsReduser